import { render, staticRenderFns } from "./businessList.vue?vue&type=template&id=b6e254ee&scoped=true&"
import script from "./businessList.vue?vue&type=script&lang=js&"
export * from "./businessList.vue?vue&type=script&lang=js&"
import style0 from "./businessList.vue?vue&type=style&index=0&id=b6e254ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e254ee",
  null
  
)

export default component.exports